import React from "react";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";
import { LightBoxViewCartIcon } from "./vectors/LightBoxCartIcons";
import { withCartIdParam } from "../../utils/BrowserHelper";

const ViewCartLink = ({
  parentName,
  colorTheme,
  cartId,
  isEmbed
}: {
  parentName: string;
  colorTheme: string;
  cartId: number;
  isEmbed: boolean;
}) => {
  return (
    <a
      href={withCartIdParam(`/checkout?source=${parentName}`, cartId, isEmbed)}
      target={isEmbed ? "_blank" : ""}
      rel={isEmbed ? "noopener noreferrer" : undefined}
      className="geo-btn view-cart-btn"
      style={{
        border: `1px solid ${ContrastForegroundUtility.lbFgColor(colorTheme)}`,
        color: ContrastForegroundUtility.lbFgColor(colorTheme)
      }}
    >
      <LightBoxViewCartIcon
        color={ContrastForegroundUtility.lbFgColor(colorTheme)}
      />
      <span
        style={{
          color: ContrastForegroundUtility.lbFgColor(colorTheme)
        }}
      >
        &nbsp; View cart
      </span>
    </a>
  );
};

export default ViewCartLink;
